// DA-12966: легенда слоя «Агрегированные потери» с переключателями и статической градиентной шкалой
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { LostDevicesH3Categories } from '../../../constants/variables';
import { LOST_DEVICES_H3_STYLE } from '../../../constants/layerStyles';
import { LOST_DEVICES_H3_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { GradientLegend } from '../../LegendRenderer';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const H3_ZOOMS = [ 6, 7, 8, 9, 10, 'auto' ]; // DA-15988: 11–12 не строятся
const LostDevicesH3Component = ({ mapFilters, onChangeMapFilters }) => {
    const { lostDevicesH3Category, lostDevicesH3Zoom } = mapFilters;
    const { renderConfig } = LOST_DEVICES_H3_LEGEND;
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleCategoryChange = ({ target: { value } }) => {
        onChangeMapFilters('lostDevicesH3Category', value);
    };
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('lostDevicesH3Zoom', value);
    };

    return (
        <div style={{ minWidth: 0, maxWidth: '100%', boxSizing: 'border-box' }}>
            <div className={styles.legHead}>
                {t`Агрегированные потери:`}
                <div style={{ fontSize: '12px', lineHeight: '15px', opacity: 0.75 }}>{t`за всё время`}</div>
            </div>

            {/* Категории — радиокнопки */}
            <StandardRadioGroup
                value={lostDevicesH3Category}
                onChange={handleCategoryChange}
            >
                {LostDevicesH3Categories.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={classnames(styles.isochroneFilterLabel, styles.wrapLabel)}
                        control={
                            <Radio
                                checked={lostDevicesH3Category === value}
                                onChange={handleCategoryChange}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: lostDevicesH3Category === value,
                                    }
                                )}
                                size="small"
                            />
                        }
                        label={i18n._(label)}
                    />
                ))}
            </StandardRadioGroup>
            <div style={{ padding: '0 10px 10px', overflowWrap: 'anywhere', fontSize: '12px', lineHeight: '15px', opacity: 0.75 }}>
                {t`Эпизоды потери в точке, где самокат потеряли. Самокаты, которые в LOST сейчас, — в слое «Потерянные самокаты».`}
            </div>

            {/* H3 Zoom контрол */}
            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={() => setIsH3ZoomExpanded(!isH3ZoomExpanded)}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(lostDevicesH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {H3_ZOOMS.map(zoom => (
                        <FormControlLabel
                            key={zoom}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={String(lostDevicesH3Zoom) === String(zoom)}
                                    onChange={handleH3ZoomChange}
                                    value={String(zoom)}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: String(lostDevicesH3Zoom) === String(zoom),
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={zoom}
                        />
                    ))}
                </StandardRadioGroup>
            )}

            {/* Статическая градиентная шкала */}
            <div style={{ marginTop: '10px' }}>
                <GradientLegend
                    items={LOST_DEVICES_H3_STYLE.total.items}
                    renderConfig={renderConfig}
                />
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, {
    onChangeMapFilters,
})(LostDevicesH3Component);

export const LostDevicesH3Legend = withDisplayedLayersCheck(
    ConnectedComponent,
    'Агрегированные потери'
);
